import type {
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200,
} from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetPartnerAdminsUser, useGetPartnerAdminsUserProfile } from '~/hooks';

type IUseUserDetailProfile = (userId: number) => {
  state: {
    data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200;
    profileData: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200;
  };
};

/**
 * 利用者詳細プロフィールのコンポーネントフック
 *
 * @param userId - 利用者ID
 */
export const useUserDetailProfile: IUseUserDetailProfile = userId => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data } = useGetPartnerAdminsUser({ threeLetterCode, userId });
  const { data: profileData } = useGetPartnerAdminsUserProfile({ threeLetterCode, userId });

  return {
    state: {
      data,
      profileData,
    },
  };
};
